module.exports = __webpack_public_path__ + "img/1-13.5f2d7221.png";